<template>
    <div>
        <router-view></router-view>
        <app-header></app-header>
        <main id="page-main">
            <header class="content-header">
                <div class="wrapper">
                    <h1>Bienvenue {{ $store.getters.user.person.firstname }}</h1>
                </div>
            </header>
            <div class="content-body">
                <div class="widgets">
                  <div class="widgets-wrapper">
                    <ScopeWidget title="Envois Email" period="last_month" provider="email" class="tierce" v-if="$aclInterfaceValidator('weeboxcore.scope.statsnotifications')"></ScopeWidget>
                    <ScopeWidget title="Envois SMS" period="last_month" provider="sms" class="tierce" v-if="$aclInterfaceValidator('weeboxcore.scope.statsnotifications')"></ScopeWidget>
                    <ScopeWidget title="Services externes (API)" period="current_year" provider="image,address" class="tierce" v-if="$aclInterfaceValidator('weeboxcore.scope.statsnotifications')"></ScopeWidget>

                    <OrderStatsWidget title="Commandes" period="current_month" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')"></OrderStatsWidget>
                    <GoogleAnalyticsWidget title="Visites du site" period="current_month"></GoogleAnalyticsWidget>

                    <StatsAquisitionCohortWidget
                        :title="'Lifetime Value / Clients'"
                        type="all"
                        period="current_year"
                        class-name="full"
                        v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsAquisitionCohortWidget>

                    <StatsBestCustomers
                        :title="'Classement des 15 clients (meilleur chiffre d\'affaire)'"
                        period="current_month"
                        class-name="full"
                        v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsBestCustomers>
                  </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import Header from '../../layouts/Header.vue'
    import ScopeWidget from '../scope/ScopeWidget.vue'
    import OrderStatsWidget from '../shop/order/OrderStatsWidget.vue'
    import GoogleAnalyticsWidget from '../google/GoogleAnalyticsWidget.vue'
    import StatsBestCustomers from '../invoicing/invoice/StatsBestCustomers.vue'
    import StatsAquisitionCohortWidget from '../invoicing/invoice/StatsAquisitionCohortWidget.vue'

    export default {
        name: 'Dashboard',
        data () {
            return {
                profiles: null,
                msg: 'Page FirstRoute'
            }
        },
        mounted: function(){
            console.log('TESTOUILLE',this.$store.state.user);
        },
        components: {
            'app-header': Header,
            'ScopeWidget': ScopeWidget,
            'OrderStatsWidget': OrderStatsWidget,
            'GoogleAnalyticsWidget': GoogleAnalyticsWidget,
            'StatsBestCustomers': StatsBestCustomers,
            'StatsAquisitionCohortWidget': StatsAquisitionCohortWidget
        },
        methods: {
            edit: function(id){
                this.$router.push('/person/'+id);
            },
            increment: function () {
                this.$store.commit('increment')
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/Dashboard.vue